var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" Produktliste "),_vm._l((_vm.datapool),function(item){return _c('div',{key:item.uid},[_vm._v(" "+_vm._s(item.uid)+_vm._s(item.name)+_vm._s(item.filepool)+" ")])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }